<template>
	<div>
		<Header :isHome="false"></Header>

		<div class="top-bg" style="padding-top: 7rem;">
			<div class="text-white" style="font-size: 16px;">Find the right service provider</div>
			<div class="text-white" :style="`${isMobile?'font-size: 0.8rem;':'font-size: 2.5rem;'}`">Start your
				Customization</div>
			<div class="container bg-white" style="margin-top: 3rem;"
				:style="`${isMobile?'padding: 1.5rem;':'padding: 3rem;'}`">
				<el-steps align-center :active="active" finish-status="success">
					<el-step title="Basic Information"></el-step>
					<el-step title="Detailed introduction"></el-step>
					<el-step title="Product Information"></el-step>
				</el-steps>
				<template v-if="active==0">
					<div style="margin-top: 2rem;">
						<div class="label df aic">
							<span class="require">*</span>
							<span>Type</span>
						</div>
						<!-- <el-select @change="selectType" style="width: 100%;" v-model="params.categoryId" clearable
							placeholder="Choose type">
							<el-option v-for="(item,index) in categories" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select> -->
						<el-cascader style="width: 100%;margin: 0;" :options="categories" v-model="categoryId"
							:props="{ expandTrigger: 'hover',value:'id',label:'name', checkStrictly: true  }"
							@change="handleChange">
							<template slot-scope="{ node, data }">
								<span>{{ data.name }}</span>
								<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
							</template></el-cascader>
					</div>
					<div style="margin-top: 2rem;">
						<div class="label df aic">
							<!-- <span class="require">*</span> -->
							<span>Brand</span>
						</div>
						<div class="df">
							<el-select style="flex: 7;" v-model="params.brand" clearable placeholder="Choose  brand">
								<el-option v-for="(item,index) in brands" :key="item.name" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
							<el-input v-if="params.brand=='Customize'" style="flex: 3;margin-left: 1rem;"
								v-model="customizeBrand" placeholder="Customize"></el-input>
						</div>
					</div>
					<div style="margin-top: 2rem;">
						<div class="label df aic">
							<span class="require">*</span>
							<span>Origin</span>
						</div>
						<div class="df">
							<el-select style="flex: 7;" v-model="params.country" clearable placeholder="Choose  Origin">
								<el-option v-for="(item,index) in countrys" :key="index" :label="item.englishName"
									:value="item.englishName">
								</el-option>
							</el-select>
							<el-input v-if="params.country=='Customize'" style="flex: 3;margin-left: 1rem;"
								v-model="customizeOrigin" placeholder="Customize"></el-input>
						</div>
					</div>
					<div style="margin-top: 2rem;">
						<div class="label">Certification</div>
						<div class="df">
							<el-select style="flex: 7;" v-model="params.authentications" clearable
								placeholder="Choose  Certification">
								<el-option v-for="(item,index) in authentications" :key="index" :label="item.name"
									:value="item.name">
								</el-option>
							</el-select>
							<el-input v-if="params.authentications=='Customize'" style="flex: 3;margin-left: 1rem;"
								v-model="customizeCertification" placeholder="Customize"></el-input>
						</div>
					</div>
					<div style="margin-top: 2rem;">
						<div class="label">Attachment</div>
						<el-button @click="clickFile"
							icon="el-icon-paperclip">{{attachmentName?attachmentName:'Upload Attachment…'}}</el-button>
					</div>
					<form action="" enctype="multipart/form-data" style="display: none;">
						<input type="file" multiple="multiple" accept="*" @change="getImg" id="file" />
					</form>
					<div style="margin-top: 2rem;">
						<div class="label df aic">
							<span class="require">*</span>
							<span>Budget</span>
						</div>
						<el-input v-model="params.budget_price" placeholder="Enter amount">
							<div style="font-size: 20px;font-weight: bold;color: #000;" slot="prefix"
								class="df aic jcc">
								<span style="transform: translate(5px,4px);">$</span>
							</div>
						</el-input>
					</div>
					<div style="margin-top: 2rem;">
						<div class="label df aic">
							<span class="require">*</span>
							<span>Title</span>
						</div>
						<el-input v-model="params.title" placeholder="Enter title"></el-input>
					</div>
					<div style="margin-top: 2rem;">
						<div class="label df aic">
							<span class="require">*</span>
							<span>Notes</span>
						</div>
						<el-input type="textarea" :rows="4" placeholder="Enter content" v-model="params.sub_title">
						</el-input>
					</div>
				</template>
				<template v-else-if="active==1">
					<div v-if="showProperties" style="margin-top: 2rem;" v-for="(item,index) in propertiesList"
						:key="item.id">
						<div class="label">{{item.label}}</div>
						<div class="df">
							<el-select style="flex: 7;" @change="change($event,item.label)"
								:value="properties[item.label]" clearable placeholder="Choose Features">
								<el-option v-for="(item2,index2) in item.property_values" :key="item2.value"
									:label="item2.value" :value="item2.value">
								</el-option>
							</el-select>
							<el-input @input="input($event,item.label)" v-if="properties[item.label]=='Customize'"
								style="flex: 3;margin-left: 1rem;" v-model="customizeProperties[item.label]"
								placeholder="Customize"></el-input>
						</div>
					</div>
				</template>
				<template v-else-if="active==2">
					<div class="title" style="margin: 1rem 0;font-weight: bold;font-size: 20px;">Product Details</div>
					<vue-editor useCustomImageHandler @image-added="handleImageAdded" v-model="params.description"
						ref="editor"></vue-editor>
				</template>
				<div class="df jcc" style="margin-top: 2rem;" v-if="active!=3">
					<el-button type="info" style="margin-right: 0.5rem;" v-if="active!=0"
						@click="previous">Back</el-button>
					<el-button v-if="active!=2" style="width: 100px;" @click="next">Next</el-button>
					<el-button v-else style="width: 100px;background-color: #22F7D3;" @click="submit">Submit</el-button>
				</div>
				<el-result v-if="active==3" icon="success" title="Submitted successfully"
					subTitle="Waiting for review...">
					<template slot="extra">
						<el-button type="primary" size="medium"
							@click="$router.push({name: 'user',query:{type:3}})">Check</el-button>
					</template>
				</el-result>
			</div>
		</div>
		<Footer style="margin-top: 3rem;"></Footer>
	</div>
</template>

<script>
	import Header from '/src/components/header.vue'
	import Footer from '/src/components/footer.vue'
	import {
		VueEditor
	} from 'vue2-editor'
	export default {
		data() {
			return {
				categoryId: [],
				attachmentName: '',
				customizeBrand: '',
				customizeOrigin: '',
				customizeCertification: '',
				active: 0,
				showProperties: true,
				params: {
					categoryId: null,
					title: "",
					sub_title: "",
					brand: "",
					description: "",
					budget_price: null,
					country: '',
					authentications: '',
					properties: "",
					attachment: ''
				},
				brands: [],
				countrys: [],
				categories: [],
				authentications: [],
				propertiesList: [],
				properties: {},
				customizeProperties: {},
				isMobile: false,
				data: {}
			}
		},
		components: {
			Header,
			Footer,
			VueEditor
		},
		mounted() {
			this.isMobile = localStorage.getItem('isMobile') == 'null' ? false : true
			this.getList();
			if (this.$route.query.id) this.getData(this.$route.query.id);
		},
		methods: {
			async getData(id) {
				let {
					data
				} = await this.$get(`/gci/product/custom/${id}/detail`);
				this.categoryId = data.categoryId;
				this.params = {
					categoryId: data.categoryId,
					title: data.title,
					sub_title: data.sub_title,
					brand: data.brand,
					description: data.description,
					budget_price: data.budget_price,
					country: data.country,
					authentications: data.authentications,
					properties: JSON.parse(data.properties),
					attachment: data.attachment
				}
			},
			handleChange(value) {
				this.params.categoryId = value[value.length - 1]
			},
			async selectType() {
				let res4 = await this.$get('/gci/authentication', {
					categoryId: this.params.categoryId
				})
				this.authentications = res4.data
				this.authentications.unshift({
					name: 'Customize'
				})
			},
			async getImg(e) {
				var file = e.target.files; //这个就是选中文件信息
				let formdata = new FormData()
				Array.from(e.target.files).map(item => {
					console.log(item)
					formdata.append("file", item) //将每一个文件图片都加进formdata
				})
				let res = await this.$post('/upload', formdata)
				this.attachmentName = res.data.name;
				this.params.attachment = res.data.url;
			},
			clickFile() {
				const input = document.querySelector('#file')
				input.click()
			},
			change(value, key) {
				this.$set(this.properties, key, value)
				this.showProperties = false;
				this.showProperties = true;
				console.log(this.properties);
				console.log(this.customizeProperties);
			},
			input(value, key) {
				this.$set(this.customizeProperties, key, value)
				this.showProperties = false;
				this.showProperties = true;
				console.log(this.properties);
				console.log(this.customizeProperties);
			},
			async getProperties() {
				let res = await this.$get(`/category/properties`, {
					categoryId: this.params.categoryId
				})
				this.propertiesList = res.data.properties
				this.propertiesList.forEach(v => {
					this.properties[v.label] = this.params.properties[v.label] ? this.params.properties[v
						.label] : "";
					this.customizeProperties[v.label] = "";
					v.property_values.unshift({
						value: 'Customize'
					})
				})
			},
			async getList() {
				let res1 = await this.$get('/brands')
				this.brands = res1.data.items
				this.brands.unshift({
					name: 'Customize'
				})
				let res2 = await this.$get('/gci/country/list')
				this.countrys = res2.data.items
				this.countrys.unshift({
					englishName: 'Customize'
				})
				let res3 = await this.$get('/categories')
				this.categories = res3.data.items
				let res4 = await this.$get('/gci/authentication')
				this.authentications = res4.data
				this.authentications.unshift({
					name: 'Customize'
				})
			},
			next() {
				console.log(this.params);
				console.log(this.properties);
				console.log(this.customizeProperties);
				if (!this.params.categoryId) return this.$bus.$emit('message', {
					type: 1,
					msg: 'Type cannot be empty!'
				})
				// if (!this.params.brand) return this.$bus.$emit('message', {
				// 	type: 1,
				// 	msg: 'Brand cannot be empty!'
				// })
				if (this.params.brand == 'Customize' && !this.customizeBrand) return this.$bus.$emit('message', {
					type: 1,
					msg: 'Brand cannot be empty!'
				})
				if (!this.params.country) return this.$bus.$emit('message', {
					type: 1,
					msg: 'origin cannot be empty!'
				})
				if (this.params.country == 'Customize' && !this.customizeOrigin) return this.$bus.$emit('message', {
					type: 1,
					msg: 'origin cannot be empty!'
				})
				if (!this.params.budget_price) return this.$bus.$emit('message', {
					type: 1,
					msg: 'budget amount cannot be empty!'
				})
				if (!this.params.title) return this.$bus.$emit('message', {
					type: 1,
					msg: 'title cannot be empty!'
				})
				if (!this.params.sub_title) return this.$bus.$emit('message', {
					type: 1,
					msg: 'sub_title cannot be empty!'
				})
				this.active += 1;
				if (this.active == 1) {
					this.getProperties()
				}
				window.scrollTo(0, 0);
			},
			previous() {
				this.active -= 1;
			},
			async submit() {
				for (let key in this.properties) {
					if (this.properties[key] == 'Customize') this.properties[key] = this.customizeProperties[key];
				}
				this.params.properties = JSON.stringify(this.properties)
				let res
				if (this.$route.query.id) {
					res = await this.$post(`/gci/product/custom/${this.$route.query.id}/edit`, this.params)
				} else {
					res = await this.$post('/gci/product/custom/add', this.params)
				}
				this.$bus.$emit('message', {
					type: 2,
					msg: res.msg
				})
				this.active = 3
			},
			handleImageAdded(file, Editor, cursorLocation, resetUploader) {
				// 引入包内自带的formdata
				const formData = new FormData();
				// 将前端传入formdata中数据名为file的数据追加到formdata,与上篇文章的图片上传相同
				formData.append("file", file);
				// 使用我们上篇文章定义好的图片上传接口,将formdata数据传到后台,并接收返回的数据到res

				this.request.post('/upload', formData).then(res => {
					if (res.status == 0) {
						this.$bus.$emit('message', {
							type: 2,
							msg: 'upload success'
						})
						// 找到返回数据中的图片链接
						let url = res.data.url;
						// 用vue-editor包自带的插入方法:在光标所在位置,插入一张图片,图片的地址是url
						Editor.insertEmbed(cursorLocation, "image", url);
						// 刷新(重置)编辑器
						resetUploader();
					}
				})
			},
		}
	}
</script>

<style scoped lang="scss">
	@media (max-width:767px) {
		.label {
			// margin: 0.3rem 0 !important;
		}

		/deep/ .el-step__title {
			line-height: 23px;
		}
	}

	/deep/ .el-cascader__dropdown .el-radio {
		margin: 0 !important;
	}

	div {
		box-sizing: border-box;
	}

	.el-button:hover {
		color: black !important;
		background-color: #23ebe2;
	}

	.top-bg {
		width: 100vw;
		font-weight: bold;
		display: flex;
		align-items: center;
		background-image: url('../../assets/imgs/customizeBg.png');
		background-size: center;
		background-position: top center;
		background-repeat: no-repeat;
		flex-direction: column;
		min-height: 575px;
	}

	.text-white {
		color: #fff;
	}

	.bg-white {
		background-color: #fff;
	}

	.label {
		font-weight: bold;
		margin: 1rem 0;
	}

	.require {
		font-weight: bold;
		font-size: 25px;
		transform: translateY(5px);
		color: crimson;
		margin-right: 5px;
	}
</style>